import React from "react";
import LanguageTable from "./List/Languagelist";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const Langauge = () => {
  
  return (
    <div className="list">
      <div className="listContainer">
        <LanguageTable/>
      </div>
    </div>
  );
};

export default Langauge;
